import React from 'react'
import { Select } from './'

export const Multiple = props => { 
    const customProps = {...props};
    customProps.element.multiple = "multiple";
    customProps.element.className += " custom-select";
    
    return (<Select {...customProps} />)
}

export default Multiple;